<template>
  <div class="match-table">
    <div class="success">
      <p>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-success-tianchong"></use>
        </svg>
        <span>
          {{props.dataList.successList.length}} Successful matches
        </span>
      </p>
      <artmisads-table
        :bordered="true"
        :columns="columnsSuccess"
        row-key="id"
        :change="onChangeSuccessPage"
        rowClassName="table-item"
        :data-source="props.dataList.successList"
        :scroll="{ y: 231 }"
        :pagination="{
          current: successPage,
          total: props.dataList.successList.length,
          defaultPageSize: 10,
        }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.name === 'commission'">
            <span :class="record.status === 'active' ? 'active-commission' : 'inactive-commission'">{{`${Number(record.commission).toFixed(1)}%`}}</span>
          </template>
          

          <template v-if="column.key === 'startDate'">
            <span>{{moment(record.startDate).format('YYYY/MM/DD')}}</span>
          </template>
           <template v-if="column.key === 'endDate'">
            <span>{{moment(record.endDate).format('YYYY/MM/DD')}}</span>
          </template>
          <template v-if="column.name === 'beforeStatus'">
            <showStatus :isActive="record?.beforeStatus.toUpperCase() === 'ACTIVE'" :noBorder="true"/>
          </template>
          <template v-if="column.name === 'afterStatus'">
            <showStatus :isActive="record?.afterStatus.toUpperCase() === 'ACTIVE'" :noBorder="true"/>
          </template>
        </template>
      </artmisads-table>
    </div>
    <div class="operation-btn">
      <!-- <artmisads-button @click="onBack">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiantou-zuo-cu"></use>
        </svg>
        Back
      </artmisads-button> -->
      <div class="update">
        <!-- <artmisads-button type="dashed" @click="onCancel">Cancel</artmisads-button> -->
        <artmisads-button v-if="props.dataList.successList.length && !loading" type="primary" @click="onUpdate">Update Successful Matched Deals </artmisads-button>
        <artmisads-button v-else disabled>Update Successful Matched Deals </artmisads-button>
      </div>
      
    </div>
    <div class="fail" v-if="props.dataList.failList.length">
      <div class="fail-top">
       <p>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-a-error-tianchong5"></use>
        </svg>
        <span>{{props.dataList.failList.length}} Failed matches</span>
      </p>
       <artmisads-select-button class="download" @click="downloadExample">
            <svg class="icon icon-daochu1" aria-hidden="true">
              <use xlink:href="#icon-daochu1"></use>
            </svg>
            Download the Template
          </artmisads-select-button>
      </div>
   
      <artmisads-table
        bordered
        :columns="columnsFail"
        row-key="id"
        rowClassName="table-item"
        :data-source="props.dataList.failList"
        :change="onChangeFailPage"
        :scroll="{ y: 275 }"
        :pagination="{
          total: props.dataList.failList.length,
          defaultPageSize: 10,
          current: failPage,
        }"
      >
        <template #bodyCell="{ column, record }">
          
        
        </template>
      </artmisads-table>
    </div>
  </div>
</template>
<script lang="jsx" setup>
  import { message } from 'ant-design-vue';
  import { ref } from 'vue';
import moment from 'moment';
  import showStatus from '@/pages/seller/Brands/components/showStatus.vue';
  import { productsApi } from '../../../../server/index'
  import { financeApi } from '~/server/operator/finance'

  const successPage = ref(1);
  const failPage = ref(1);
  const loading = ref(false);

  const props = defineProps([
    'dataList', 'setDataList', 'setShowExample', 'setShowUpdateProductModal', 'getProductList', 'onCancel'
  ]);

  const onChangeSuccessPage = ({ current }) => {
    successPage.value = current;
  }

  const onChangeFailPage = ({ current }) => {
    failPage.value = current;
  }

  const onUpdate = async () => {
    loading.value = true;
    let params = {deals:[...props.dataList.successList]};
    // params = params.map(item => {
    //   item.commission = item.afterCommissionStr;
    //   item.status = item.afterStatus;
    //   return item;
    // })
    let res = await financeApi.productDealUpdateCsv(params);
    const { success, error } = res;
    if (success) {
      message.success('Success');
      props.setDataList({
        successList: [],
        failList: [...props.dataList.failList],
      });
      props.getProductList();
      // props.onCancel();
    }
    loading.value = false;
  }

  const onBack = () => {
    props.setDataList({
      failList: [],
      successList: []
    });
    props.setShowExample(true);
  }

  const columnsFail = ref([
  {
    title:'Seller Account',
    dataIndex: 'amazonSellerEmail',
  },
  {
    title:"marketplace",
    dataIndex: 'marketplace',
  },
    {
      title: 'ASIN',
      dataIndex: 'asin',
    },
    {
      title: 'Amazon Seller Name',
      dataIndex: 'amazonSellerAccount',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title:'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title:"Full Price",
      dataIndex: 'fullPrice',
    },
    {
      title:"Final Price",
      dataIndex: 'finalPrice',
    },
    {
      title:"Deal Type",
      dataIndex: 'dealType',
    },
    {
      title:"Promo Code",
      dataIndex: 'promoCode',
    },
    {
      title:"Failed Reason",
      dataIndex: 'failedReason',
    }
  ])

  const columnsSuccess = ref([
   {
    title:'Seller Account',
    dataIndex: 'amazonSellerAccount',
  },
  {
    title:"marketplace",
    dataIndex: 'marketplace',
  },
    {
      title: 'ASIN',
      dataIndex: 'asin',
    },
    {
      title: 'Amazon Seller Name',
      dataIndex: 'amazonSellerEmail',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title:'End Date',
      dataIndex: 'endDate',
      key: 'endDate',

    },
    {
      title:"Full Price",
      dataIndex: 'fullPrice',
    },
    {
      title:"Final Price",
      dataIndex: 'finalPrice',
    },
    {
      title:"Deal Type",
      dataIndex: 'dealType',
    },
    {
      title:"Promo Code",
      dataIndex: 'promoCode',
    },
   
  ])
    const downloadExample=()=>{
      // 定义CSV的列标题
      const headers = [
        'Seller Account',
        'marketplace',
        'ASIN',
        'Amazon Seller Name',
        'Start Date',
        'End Date',
        'Full Price',
        'Final Price',
        'Deal Type',
        'Promo Code',
       
      ];
      
      // 创建CSV行数组
      const csvRows = [];
      // 添加标题行
      csvRows.push(headers.map(header => `"${header}"`).join(','));
      
      // 添加failList数据行
      if (props.dataList?.failList && props.dataList.failList.length > 0) {
        props.dataList.failList.forEach(item => {
          const row = [
            `"${item.amazonSellerEmail || ''}"`,
            `"${item.marketplace || ''}"`,
            `"${item.asin || ''}"`,
            `"${item.amazonSellerAccount || ''}"`,
            `"${item.startDate || ''}"`,
            `"${item.endDate || ''}"`,
            `"${item.fullPrice || ''}"`,
            `"${item.finalPrice || ''}"`,
            `"${item.dealType || ''}"`,
            `"${item.promoCode || ''}"`,
         
          ];
          csvRows.push(row.join(','));
        });
      }
      
      // 合并所有行
      const csvContent = csvRows.join('\n');
      
      // 创建Blob对象
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      
      // 创建下载链接
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      // 设置下载属性
      link.setAttribute('href', url);
      link.setAttribute('download', `FailureDealsDatas.csv`);
      link.style.visibility = 'hidden';
      
      // 添加到文档并触发点击
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // 清理URL对象
      URL.revokeObjectURL(url);
      
      message.success('Fail list data downloaded successfully');
    }
</script>

<style lang="less" scoped>
.download{
  display: flex;
  gap: 6px;
  align-items: center;
}
  .match-table {
    padding-bottom: 12px;
    .success,
    .fail {
    .fail-top{
         margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 16px;
       p {
        display: flex;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        line-height: 20px;
     
        font-weight: 500;
        svg {
          width: 24px;
          height: 24px;
          margin-right: 5px;
        }
        > span {
          align-self: center;
          font-size: 16px;
        }
      }
    }
      
    }
    
    .success {
      padding: 8px 0 2px;
      > p {
        :deep(svg) {
          fill: var(--green-3);
        }
      }
    }
    .fail {
      margin: 0 -24px -24px;
      border-radius: 0 0 8px 8px;
      padding: 24px 24px 8px 24px;
      background-color: var(--bg-gray-1);
      border-top: 1px solid var(--border-4);
      > p {
        svg {
          fill: var(--red-1);
        }
      }
    }
    .operation-btn {
      display: flex;
      justify-content: space-between;
      padding-bottom: 24px;
      > button {
        display: flex;
        svg {
          align-self: center;
          width: 18px;
          height: 18px;
          fill: var(--dark-2);
          margin-right: 8px;
        }
        :deep(span) {
          align-self: center;
        }
      }
      .update {
        > button {
          margin-left: 8px;
        }
      }
    }
    :deep(.ant-table) {
      .ant-table-cell {
        word-break: break-word;
        padding: 16px;
        line-height: 20px;
        border-color:  var(--border-4) !important;
      }
      .ant-table-thead {
        border-radius: 8px 8px 0 0;
        overflow: hidden;
        .ant-table-cell {
        border-color:  var(--border-1) !important;
        border-inline-end-color: var(--border-1) !important;
        }
      }
      .ant-table-container {
        border-color:  var(--border-4) !important;
      }
      table {
        border-top: none !important;
        border-color:  var(--border-4) !important;
      }
      .inactive-commission {
        color: var(--dark-4);
      }
      .status-text {
        text-transform: capitalize;
      }
      .product-item {
        display: flex;
        img {
          width: 60px;
          height: 60px;
          margin-right: 10px;
          object-fit: contain;
        }
        .text {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          justify-content: center;
          .title {
            max-width: 300px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .asin {
            margin-top: 4px;
          }
        }
      }
    }
  }
  
</style>